import {useCallback, useState} from 'react';

export function useToggle(initialValue: boolean) {
	const [state, setState] = useState(initialValue);
	const on = useCallback(() => setState(true), []);
	const off = useCallback(() => setState(false), []);
	const toggle = useCallback(() => setState(prevState => !prevState), []);
	return [state, {off, on, toggle}] as const;
}
